// extracted by mini-css-extract-plugin
module.exports = {"links":"Links_links__4OrQl","tutorial":"Links_tutorial__rHj6j","community":"Links_community__2P-15","link":"Links_link__qxD6v"};